import React from 'react';
import createSvgIcon from '../../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M15.8645 14.3208h-.813l-.2882-.2779c1.0086-1.1733 1.6158-2.6964 1.6158-4.3534C16.3791 5.9948 13.3842 3 9.6895 3S3 5.9948 3 9.6895s2.9948 6.6896 6.6895 6.6896c1.657 0 3.1801-.6072 4.3534-1.6158l.2779.2882v.813L19.4666 21 21 19.4666zm-6.175 0c-2.5626 0-4.6312-2.0687-4.6312-4.6313S7.127 5.0583 9.6895 5.0583s4.6313 2.0686 4.6313 4.6312-2.0687 4.6313-4.6313 4.6313M7.1166 9.175h5.1458v1.0291H7.1166z" /></g>,<defs key="1"></defs>,]
, 'CameraPhotoZoomOutx');
